// @ts-strict-ignore
import React from 'react';
import { TextField, TextArea } from '@usealloy/component-library';
import { StyledAggregationNameDescriptionContainer } from './styles';
import type { AggregationConfigFormFields } from './types';

type NameDescriptionKey = keyof Pick<AggregationConfigFormFields, 'name' | 'description'>;

type AggregationNameAndDescriptionProps = {
  formFields: AggregationConfigFormFields;
  onFormFieldChange: React.Dispatch<React.SetStateAction<AggregationConfigFormFields>>;
};

const AggregationNameAndDescription = ({
  formFields,
  onFormFieldChange,
}: AggregationNameAndDescriptionProps) => {
  const handleChange = (field: NameDescriptionKey) => (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => onFormFieldChange(prev => ({ ...prev, [field]: e.target.value }));
  return (
    <StyledAggregationNameDescriptionContainer>
      <TextField
        label="Aggregation Name"
        value={formFields.name}
        onChange={handleChange('name')}
        type="text"
        required
      />
      <TextArea
        label="Description"
        value={formFields.description}
        onChange={handleChange('description')}
        rows={3}
        required
        placeholder="Enter a description for your aggregation."
      />
    </StyledAggregationNameDescriptionContainer>
  );
};

export default AggregationNameAndDescription;
